var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-groups 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-groups"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M39.4641 45.248C40.7558 45.3802 42.0535 45.4446 43.3521 45.44C47.1866 45.6968 51.0259 45.013 54.5361 43.448C54.7209 43.3412 54.874 43.1871 54.9796 43.0016C55.085 42.8158 55.139 42.6056 55.1362 42.392C55.1362 37.592 50.3361 34.136 43.6641 34.136C40.2791 33.9526 36.9535 35.0782 34.3761 37.28M43.6641 28.5681C44.8185 28.5728 45.9484 28.2348 46.9106 27.5968C47.873 26.9589 48.6242 26.0497 49.0691 24.9845C49.5143 23.9193 49.6331 22.7459 49.4109 21.613C49.1887 20.4802 48.635 19.4387 47.8204 18.6207C47.0059 17.8027 45.9667 17.2449 44.8346 17.0179C43.7027 16.7909 42.5289 16.905 41.4619 17.3457C40.3948 17.7864 39.4826 18.5339 38.8406 19.4935C38.1988 20.4531 37.8561 21.5816 37.8561 22.7361C37.8561 24.2786 38.4671 25.7584 39.5558 26.8514C40.6442 27.9444 42.1214 28.5618 43.6641 28.5681ZM23.912 29.504C25.4452 29.504 26.944 29.0494 28.2189 28.1975C29.4935 27.3457 30.4871 26.135 31.0739 24.7186C31.6607 23.302 31.8141 21.7434 31.5151 20.2396C31.216 18.7359 30.4778 17.3546 29.3935 16.2705C28.3094 15.1864 26.9282 14.4481 25.4244 14.149C23.9207 13.8498 22.362 14.0034 20.9455 14.5901C19.529 15.1768 18.3183 16.1704 17.4665 17.4452C16.6147 18.72 16.1601 20.2188 16.1601 21.752C16.1664 23.806 16.9852 25.7741 18.4376 27.2265C19.89 28.6789 21.858 29.4975 23.912 29.504ZM23.9121 35.192C14.9121 35.192 8.60011 39.752 8.60011 46.232C8.59898 46.4955 8.66164 46.7554 8.78286 46.9897C8.90406 47.2237 9.08015 47.4248 9.29606 47.576C9.70406 47.84 13.5681 50.288 23.5281 50.288C33.4881 50.288 38.2641 47.744 38.4321 47.624C38.6759 47.4834 38.8778 47.2801 39.017 47.0355C39.1562 46.7907 39.2277 46.5135 39.2241 46.232C39.3201 39.752 32.9361 35.192 23.9121 35.192Z",
    stroke: "#D1D5DB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoGroup);
export default __webpack_public_path__ + "static/media/icon-no-group.1d1379b17a2453db394ad936209cb8a1.svg";
export { ForwardRef as ReactComponent };